import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as ShowSVG } from '../../assets/show.svg';
import { ReactComponent as HideSVG } from '../../assets/hide.svg';
import styled from 'styled-components';
import { urlSlug } from '../../data/helpers';

const MyWorkouts = styled.div`
  margin-bottom: 1.5rem;
`;

const MyWorkoutsToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: .5rem;
  cursor: pointer;
`;

const MyWorkoutsTitle = styled.h3`
  color: #e5e9f0;
  font-size: .875rem;
  font-weight: 900;
  text-transform: uppercase;
`;

const MyWorkoutsList = styled.ul`
  overflow: hidden;
  transition: height 0.3s ease-out;
`;

export const ShowIcon = styled(ShowSVG)`
  stroke: #fff;
  width: .75rem;
  height: .75rem;
  backface-visibility: hidden;
  overflow: hidden;
  vertical-align: middle;
`;

export const HideIcon = styled(HideSVG)`
  stroke: #fff;
  width: .75rem;
  height: .75rem;
  backface-visibility: hidden;
  overflow: hidden;
  vertical-align: middle;
`;

const Workouts = ({ workouts }) => {
  const [showWorkouts, setShowWorkouts] = useState(true);
  const [height, setHeight] = useState();
  const list = useRef(null);

  useEffect(() => setHeight(list.current.clientHeight), []);

  return (
    <MyWorkouts>
      <MyWorkoutsToggle onClick={() => setShowWorkouts(!showWorkouts)}>
        <MyWorkoutsTitle>My Workouts</MyWorkoutsTitle>
        {showWorkouts ? <HideIcon /> : <ShowIcon />}
      </MyWorkoutsToggle>

      <MyWorkoutsList ref={list} style={{ height: showWorkouts ? height+'px' : 0 }}>
        {workouts && workouts.map((w, i) => (
          <li key={i}>
            <NavLink
              to={{
                pathname: `/workouts/${urlSlug(w)}`,
                state: { workout: w }
              }}
              className="NavLink"
              activeClassName="NavLink--selected">
              {w}
            </NavLink>
          </li>
        ))}
      </MyWorkoutsList>
    </MyWorkouts>
  );
}

export default Workouts;
